export const noise = {
	showOnDay: true,
	graphType:'noise',
	chart: {    
		type: 'line',
		zoomType: 'x',
		marginTop:0,
		plotBands:null,
		panning: true,
		panKey: 'shift',
		events: {
			redraw: function () {},
			selection: function(event){},
			click: function(event){}
		},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}
		
	},
	credits:{
		enabled: false
	},
	title:{
		text:''
	},
	xAxis:{
		type: 'datetime',
		minTickInterval: 1000,
		events: { 
			setExtremes: function(event){ } 
		},
		plotBands:[]
	},
	yAxis: {
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function () {
			var positions = [],
				tick = Math.floor(this.dataMin),
				increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment>0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons:{ 
        	contextButton:{ 
				enabled: false 
			} 
		}, 
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080,
	},
	plotOptions: {
		line: {
			enableMouseTracking: true,
			marker: {
				radius: 0
			},	
			lineWidth: 1,	
			animation: true,	
		},
		series: {
			pointInterval: 1000,
			events:{
				legendItemClick: function(event){},
				click: function(event){}
			},
		},
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		valueSuffix: ' dB',
		followTouchMove: true
	},
};

export const weather = {
	showOnDay: true,
	graphType:'weath',

	chart: {    
		type: 'line',
		zoomType: 'x',
		marginTop:0,
		plotBands:null,
		panning: true,
		panKey: 'shift',
		events: {
			redraw: function () {},
			selection: function(event){} 
		},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}
	},
	credits:{
		enabled: false
	},
	title:{
		text:''
	},
	xAxis:{
		type: 'datetime',
		minTickInterval: 1000,
		events: { 
			setExtremes: function(event){ } 
		}, 
		plotBands:[]
	},
	yAxis: {
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function () {
			var positions = [],
				tick = Math.floor(this.dataMin),
				increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment>0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons:{ 
        	contextButton:{ 
				enabled: false 
			} 
		}, 
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080,
	},
	plotOptions: {
		line: {
			enableMouseTracking: true,
			marker: {
				radius: 0
			},	
			lineWidth: 1,	
			animation: true,	
		},
		series: {
			pointInterval: 1000,
			events:{
				
			}
		},
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		followTouchMove: true
	},
};

export const spectogram = {
	showOnDay: false,
	graphType:'spect',
	frequencies : ["6.3 Hz","8.0 Hz","10.0 Hz","12.5 Hz","16.0 Hz","20.0 Hz","25.0 Hz","31.5 Hz","40.0 Hz","50.0 Hz","63.0 Hz","80.0 Hz","100.0 Hz","125.0 Hz","160.0 Hz","200.0 Hz","250.0 Hz","315.0 Hz","400.0 Hz","500.0 Hz","630.0 Hz","800.0 Hz","1.0k Hz","1.25k Hz","1.6k Hz","2.0k Hz","2.5k Hz","3.15k Hz","4.0k Hz","5.0k Hz","6.3k Hz","8.0k Hz","10.0k Hz","12.5k Hz","16.0k Hz","20.0k Hz", "", "LEQ"],
	chart: {    
		type: 'column',
		zoomType: '',
		marginTop:0,
		animation:false,
		panning: true,
		events: {
			redraw: function () {},
			selection: function(event){} 
		},
	},
	credits:{
		enabled: false
	},
	title:{
		text:''
	},
	xAxis:{
		type: 'category',
		labels: {
			style: {
				fontSize: '13px',
				fontFamily: 'Verdana, sans-serif'
			}
		}
	},
	yAxis: {
		title: {
			text: ''
		},
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function () {
			var positions = [],
				tick = Math.floor(this.dataMin),
				increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment>0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons:{ 
        	contextButton:{ 
				enabled: false 
			} 
		}, 
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080,
	},
	plotOptions: {
		series: {
			events:{
				
			}
		},
	},
	/*series: [{
		name: 'Spectrum',
		data: [],
		color: '#ff0000',
		visible: true,
	},{
		name: 'A Spectrum',
		data: [],
		color: '#ff00ff',
		visible: true,
	}],*/
	tooltip: {
		shared: true,
		crosshairs: true,
		followTouchMove: true,
		valueSuffix: ' dB'
	},
	legend: {
		floating: true,
		align: 'right',
		verticalAlign: 'top',
		x:-50,
		y: -15
	},
};

export const adio = {
	showOnDay: true,
	graphType:'adio',
	chart: {    
		type: 'line',
		zoomType: 'x',
		marginTop:0,
		plotBands:null,
		panning: true,
		events: {
			redraw: function () {},
			selection: function(event){} 
		},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}
		
	},
	credits:{
		enabled: false
	},
	title:{
		text:''
	},
	xAxis:{
		type: 'datetime',
		minTickInterval: 1000,
		events: { 
			setExtremes: function(event){ } 
		},
		plotBands:[]
	},
	yAxis: [{
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function () {
			var positions = [],
				tick = Math.floor(this.dataMin),
				increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment>0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	{
		opposite:true,
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function () {
			var positions = [],
				tick = Math.floor(this.dataMin),
				increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment>0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	}],
	exporting: {
		buttons:{ 
        	contextButton:{ 
				enabled: false 
			} 
		}, 
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080,
	},
	plotOptions: {
		line: {
			enableMouseTracking: true,
			marker: {
				radius: 0
			},	
			lineWidth: 1,	
			animation: true,	
		},
		series: {
			pointInterval: 1000,
			events:{
				legendItemClick: function(event){}
			}
		},
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		valueSuffix: ' ',
		followTouchMove: true
	},
};



export const statistics = {
	
	showOnDay:true,
	graphType:'statistics',
	title:{
		text:''
	},
	global: {
		setUTC: false
	},
	chart:{
		panning: true,
		events: { 
		},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}
		
	},
	credits:{
		enabled: false
	},
	xAxis: {
		type: 'datetime',
		labels: {
			format: '{value:%H}',
		},
		tickInterval: 3600000,
		events: { 
		},
	},
	yAxis: {
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function () {
			var positions = [],
				tick = Math.floor(this.dataMin),
				increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment>0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons:{ 
        	contextButton:{ 
				enabled: false 
			} 
		}, 
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080,
	},
	plotOptions: {
		line: {
			dataLabels: {
				enabled: false
			},
			enableMouseTracking: true,
			marker: {
				radius: 0
			},
			lineWidth: 1,
			animation: false
		},
		series: {
			//pointStart: Date.parse(line[0].substr(0,10)),
			pointInterval: 3600 * 1000,
			events:{
			},
		}
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		valueSuffix: ' dB'
	},
	/*measurement = "2018-01-30"
line = array(data)
graph = $('#graph').highcharts({
	title: {
		text: measurement
	},
	global: {
		setUTC: false
	},
	 xAxis: {
		type: 'datetime',
		labels: {
			format: '{value:%H}',
		},
		tickInterval: 3600000
	},
	yAxis: {
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
	},
	exporting: {
			enabled: true,
			filename: measurement + '_statistic',
			width: 1920,
			height: 1080,
		},
	plotOptions: {
		line: {
			dataLabels: {
				enabled: false
			},
			enableMouseTracking: true,
			marker: {
				radius: 0
			},
			lineWidth: 1,
			animation: false
		},
		series: {
			pointStart: Date.parse(line[0].substr(0,10)),
			pointInterval: 3600 * 1000 
		}
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		valueSuffix: ' dB'
	},
	series: [{
		type: 'line',
		name: 'Leq',
		step: 'Leq',
		data: leq,
		color: 'red',
		lineWidth: 1,

	},{
		name: 'L1%',
		step: 'L1%',
		data: l1,
		lineWidth: 1,
		color: '#7cb5ec',
	},{
		name: 'L95%',
		step: 'L95%',
		data: l95,
		lineWidth: 1,
		color: 'green'
	}]
}).highcharts(); */
}


// WEBPACK FOOTER //
// ./src/components/graphs/graph-configs.js